import React from "react";

type Props = {};

const Settings = (props: Props) => {
  return <div>Settings</div>;
};

export default Settings;
